import Pikaday from 'pikaday';
import moment from 'moment'
import 'pikaday/css/pikaday.css';

export default {
    bind: (el, binding) => {
        el.pikadayInstance = new Pikaday({
            field: el,
            onSelect: () => {
                var event = new Event('input', { bubbles: true });
                el.dispatchEvent(event);
            },
            setDefaultDate: false,
            position: 'bottom_left',
            format: 'DD.MM.YYYY',
            keyboardInput: true,
            // add more Pikaday options below if you need
            // all available options are listed on https://github.com/dbushell/Pikaday
            i18n: {
                previousMonth : 'vorheriger Monat',
                nextMonth     : 'Nachster Monat',
                months        : ['Jänner','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
                weekdays      : ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
                weekdaysShort : ['So','Mo','Di','Mi','Do','Fr','Sa']
            }
        });
    },

    unbind: (el) => {
        el.pikadayInstance.destroy();
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/directives/pikaday.js